// Configuration file for the Sentinel frontend application
// This file contains environment-specific settings
import axios from 'axios';

const config = {
  // Base URL for the application
  baseUrl: 'https://sentinel.percepto.co',

  // API base URL - Using CloudFront distribution URL
  apiBaseUrl: 'https://sentinel.percepto.co/api',

  // CloudFront will proxy these requests to API Gateway with the API key

  // Application version
  version: '1.0.0',

  // Other configuration parameters can be added here
  // such as feature flags, themes, etc.
};

// Create axios instance with default config
const api = axios.create({
  baseURL: config.apiBaseUrl,
});

// Add request interceptor to include JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export { api };
export default config;